import { render, staticRenderFns } from "./ApprovalStatistics.vue?vue&type=template&id=357ebe30&scoped=true&"
import script from "./ApprovalStatistics.vue?vue&type=script&lang=js&"
export * from "./ApprovalStatistics.vue?vue&type=script&lang=js&"
import style0 from "./ApprovalStatistics.vue?vue&type=style&index=0&id=357ebe30&prod&lang=scss&scoped=true&"
import style1 from "./ApprovalStatistics.vue?vue&type=style&index=1&id=357ebe30&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "357ebe30",
  null
  
)

export default component.exports